module.exports = __webpack_public_path__ + "img/radio-button-selected.37cfe1d3.svg";